export const IMPORT_SOURCES = [
  "mee6",
  "lurkr",
  "kiai",
  "amari",
  "atlas",
  "tatsu",
  "juniper",
  "file",
  "roles",
  "messages",
  "claims",
] as const;

export type ImportSource = (typeof IMPORT_SOURCES)[number];

export const FETCH_SOURCES = [
  "mee6",
  "lurkr",
  "kiai",
  "amari",
  "atlas",
  "tatsu",
  "juniper",
] as const satisfies readonly ImportSource[];

export type FetchSource = (typeof FETCH_SOURCES)[number];

export const JUNIPER_PAGE = 100;

export const juniperBoardUrl = (guildId: string, page: number): string =>
  `https://juniper.bot/api/public/ranking/list/${encodeURIComponent(guildId)}?page=${page}&size=${JUNIPER_PAGE}`;

export const FILE_EXPORT_SOURCES = ["lurkr", "kiai", "polaris"] as const;

export type FileExportSource = (typeof FILE_EXPORT_SOURCES)[number];
